import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { normalizeAnalyticsPath } from "@/app/pageview-path";
import { trackPageview } from "@/services/analytics";
import { getConsent } from "@/services/consent/consent";

/**
 * Fires a manual $pageview on every route change. `capture_pageview` is off
 * (posthog.ts — manual tracking only), so nothing does this automatically.
 * Gated on analytics consent, same as every other event; re-checks consent
 * on each navigation rather than once, so a mid-session consent change takes
 * effect from the next page view without needing a reload.
 *
 * Mount once, inside <BrowserRouter> (needs router context for useLocation).
 */
export function PageviewTracker(): null {
  const location = useLocation();
  useEffect(() => {
    if (getConsent()?.analytics) {
      void trackPageview(normalizeAnalyticsPath(location.pathname));
    }
  }, [location.pathname]);
  return null;
}
